class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.current = 0;
    if (!this.querySelectorAll(".cart-upsell_product")) return;
    this.lenght = this.querySelectorAll(".cart-upsell_product").length;
    this.itemSize = this.querySelector(".cart-upsell_product").clientWidth;
    this.touchstartX = 0;
    this.touchendX = 0;

    if (this.lenght > 1) {
      this.querySelector(".cart-upsell_prev").style.display = "block";
      this.querySelector(".cart-upsell_next").style.display = "block";
    }

    this.querySelector(".cart-upsell_prev").addEventListener("click", () => {
      if (this.current === 0) return;
      this.current += 1;
      this.querySelector(".cart-upsell_next").style.opacity = "1";
      if (this.current === 0) {
        this.querySelector(".cart-upsell_prev").style.opacity = "0.5";
      }
      this.querySelectorAll(".cart-upsell_product").forEach(
        (item) =>
          (item.style.transform = `translateX(${
            this.current * this.itemSize
          }px)`)
      );
    });

    this.querySelector(".cart-upsell_next").addEventListener("click", () => {
      if (this.current === -(this.lenght - 1)) return;
      this.current -= 1;
      this.querySelector(".cart-upsell_prev").style.opacity = "1";
      if (this.current === -(this.lenght - 1)) {
        this.querySelector(".cart-upsell_next").style.opacity = "0.5";
      }

      this.querySelectorAll(".cart-upsell_product").forEach(
        (item) =>
          (item.style.transform = `translateX(${
            this.current * this.itemSize
          }px)`)
      );
    });

    this.addEventListener("touchstart", (e) => {
      this.touchstartX = e.changedTouches[0].screenX;
    });

    this.addEventListener("touchend", (e) => {
      this.touchendX = e.changedTouches[0].screenX;
      this.checkDirection();
    });

    this.querySelectorAll(
      ".cart-upsell_product .product__add-to-cart-button"
    ).forEach((button) => {
      button.addEventListener("click", () =>
        this.addToCart(button.getAttribute("product-id"))
      );
    });
  }

  checkDirection() {
    if (this.touchendX < this.touchstartX)
      this.querySelector(".cart-upsell_next").click();
    if (this.touchendX > this.touchstartX)
      this.querySelector(".cart-upsell_prev").click();
  }

  addToCart(id) {
    var formData = {
      items: [
        {
          id: parseInt(id),
          quantity: 1,
          properties: {},
        },
      ],
    };
    this.querySelector(
      `.product__add-to-cart-button[product-id="${id}"]`
    ).innerHTML = "Adicionando...";
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        document.querySelector(
          `.cart-upsell_product[product-id="${id}"]`
        ).style.display = "none";
        const ajaxCartReload = () =>
          fetch(window.location.pathname + "?sections=main-cart-items")
            .then((res) => res.json())
            .then((res) => {
              const parser = new DOMParser();
              const htmlDoc = parser.parseFromString(
                res["main-cart-items"],
                "text/html"
              );
              document.querySelector("#main-cart-items").innerHTML =
                htmlDoc.querySelector("#main-cart-items").innerHTML;
              document.querySelector(
                "#cart-free-shipping-indicator"
              ).innerHTML = htmlDoc.querySelector(
                "#cart-free-shipping-indicator"
              ).innerHTML;
              document
                .querySelectorAll("[data-cart-item-input-quantity]")
                .forEach((quantityInput) =>
                  quantityInput.addEventListener("change", (e) => {
                    {
                      window.cart._onItemQuantityChange(e, window.ajaxCart);

                      setTimeout(() => {
                        return ajaxCartReload();
                      }, 1000);
                    }
                  })
                );
            });

        ajaxCartReload();
      })
      ["catch"](function (error) {
        console.error("Error:", error);
      });
  }
}

customElements.define("cart-upsell", CartUpsell);
